import React, { useState, useEffect } from 'react';
import { Box, Container, Text, Button, Group } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Hero images for the carousel
  const heroImages = [
    {
      src: "https://toronto.citynews.ca/wp-content/blogs.dir/sites/10/2022/11/08/Centennial-Park-in-Etobicoke-1536x712.jpg",
      alt: "Toronto park landscape",
      title: "Amrit Vela Sadhana",
      subtitle: "A 4:00AM Crowning Achievement"
    },
    {
      src: "https://firebasestorage.googleapis.com/v0/b/meetingcardapp.firebasestorage.app/o/admin-uploads%2FjjKnWQw2dJdi0CCA1klGM0xdO6X2%2F1753996032695_Screenshot_2025-07-31_170618.png?alt=media&token=1bf15667-aee3-4eea-95a5-8aa0df97f765",
      alt: "Sacred practice session",
      title: "62 Minute Chanting",
      subtitle: "Join our community in 2.5 hours of transformation"
    },
    {
      src: "https://youngyogamasters.com/wp-content/uploads/2013/03/Guru-Ram-Das-Ashram-Toronto.jpg",
      alt: "Guru Ram Das Ashram Toronto",
      title: "Toronto Spiritual Community",
      subtitle: "Experience the power of group meditation and kirtan"
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <Box className="hero-banner">
      <style>
        {`
          .hero-container {
            position: relative;
            height: 400px;
            overflow: hidden;
            border-radius: 0;
          }
          
          .hero-slide {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: opacity 0.8s ease-in-out;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }
          
          /* Special handling for third slide with different aspect ratio */
          .hero-slide:nth-child(3) {
            background-size: contain;
            background-position: center;
            background-color: var(--charcoal);
          }
          
          .hero-slide.active {
            opacity: 1;
          }
          
          .hero-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(
              135deg,
              rgba(244, 196, 48, 0.3) 0%,
              rgba(230, 126, 91, 0.4) 50%,
              rgba(54, 69, 79, 0.6) 100%
            );
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .hero-content {
            text-align: center;
            color: white;
            z-index: 5;
            max-width: 800px;
            padding: 0 2rem;
          }
          
          .hero-title {
            font-size: 3.5rem;
            font-weight: 700;
            margin-bottom: 1rem;
            text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
            letter-spacing: -1px;
          }
          
          .hero-subtitle {
            font-size: 1.4rem;
            font-weight: 300;
            margin-bottom: 2rem;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
            font-style: italic;
          }
          
          .carousel-controls {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 12px;
            z-index: 10;
          }
          
          .carousel-dot {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.5);
            cursor: pointer;
            transition: all 0.3s ease;
            border: 2px solid rgba(244, 196, 48, 0.7);
          }
          
          .carousel-dot.active {
            background: var(--saffron-bright);
            transform: scale(1.3);
            box-shadow: 0 0 12px rgba(244, 196, 48, 0.8);
          }
          
          .nav-button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(244, 196, 48, 0.8);
            border: none;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            z-index: 10;
            backdrop-filter: blur(10px);
          }
          
          .nav-button:hover {
            background: var(--saffron-bright);
            transform: translateY(-50%) scale(1.1);
            box-shadow: 0 4px 16px rgba(244, 196, 48, 0.6);
          }
          
          .nav-button.prev {
            left: 20px;
          }
          
          .nav-button.next {
            right: 20px;
          }
          
          /* Mobile Responsive */
          @media (max-width: 768px) {
            .hero-container {
              height: 300px;
            }
            
            .hero-title {
              font-size: 2.5rem;
            }
            
            .hero-subtitle {
              font-size: 1.1rem;
            }
            
            .nav-button {
              width: 40px;
              height: 40px;
            }
            
            .nav-button.prev {
              left: 10px;
            }
            
            .nav-button.next {
              right: 10px;
            }
          }
          
          @media (max-width: 480px) {
            .hero-container {
              height: 250px;
            }
            
            .hero-title {
              font-size: 2rem;
            }
            
            .hero-subtitle {
              font-size: 1rem;
            }
            
            .hero-content {
              padding: 0 1rem;
            }
          }
        `}
      </style>

      <div className="hero-container">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image.src})` }}
          >
            <div className="hero-overlay">
              <div className="hero-content">
                <h1 className="hero-title">{image.title}</h1>
                <p className="hero-subtitle">{image.subtitle}</p>
              </div>
            </div>
          </div>
        ))}

        {/* Navigation Buttons */}
        <button className="nav-button prev" onClick={prevSlide}>
          <IconChevronLeft size={24} color="white" />
        </button>
        <button className="nav-button next" onClick={nextSlide}>
          <IconChevronRight size={24} color="white" />
        </button>

        {/* Carousel Dots */}
        <div className="carousel-controls">
          {heroImages.map((_, index) => (
            <div
              key={index}
              className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </Box>
  );
};

export default HeroBanner;
